var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('echarts',{key:_vm.chartId,attrs:{"containerId":_vm.chartId,"options":_vm.options,"refreshToken":_vm.chartId,"type":"chart_big"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }